<template>
  <div class="sidebar-items-group">
    <b-button
      squared
      block
      :variant="variant"
      class="sidebar-items-group__toggle-button"
      @click="toggleVisibility"
    >
      {{ title }}
      <transition name="fade">
        <div class="sidebar-items-group__collapse-state-icon">
          <b-icon v-if="isVisible" icon="chevron-bar-down" />
          <b-icon v-else icon="chevron-bar-up" />
        </div>
      </transition>
    </b-button>
    <b-collapse v-model="isVisible">
      <slot></slot>
    </b-collapse>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false
    },
    variant: {
      type: String,
      required: false,
      default: "light"
    },
    defaultVisibility: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      isVisible: this.defaultVisibility
    };
  },
  methods: {
    toggleVisibility() {
      this.isVisible = !this.isVisible;
    }
  }
};
</script>

<style lang="scss">
.sidebar-items-group {
  &__toggle-button {
    display: flex !important;
    width: 100%;
    flex-direction: row !important;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    height: 50px;
  }
}

.fade-v-enter-active,
.fade-v-leave-active {
  transition: opacity 0.5s;
}
.fade-v-enter,
.fade-v-leave-to {
  opacity: 0;
}
</style>
